import { View } from '../types.js'
import { ViewBaseProps } from '../views/base/base.js'
import { getNotificationListProps } from './notifications.js'
import { getNavigationProps } from './sidebar.js'

export const getBaseProps = (view: View): ViewBaseProps => {
    // When a tool view is rendered inside the detail panel overlay,
    // hide the old top navigation — the panel header handles navigation.
    const isInsideDetailPanel = view.state.route.raw !== '/portal'

    return {
        notifications: getNotificationListProps(view),
        navigation: isInsideDetailPanel ? undefined : getNavigationProps(view),
    }
}
